














import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageDialog } from '../../utils/MessageDialog';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { StudentService } from '../../biz/remote/StudentService';
import SimpleCheckBox from '../../components/inputs/SimpleCheckBox.vue';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';
import { Session } from '../../utils/Session';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';

class SelectedTeacher extends TeacherInfoInputDTO {
  selected? = false;
}
@Component({ components: { CommonDialog, SimpleCheckBox } })
export default class DaSelectCourseDialog extends Vue {
  private title = '';
  private teachers: SelectedTeacher[] = [];
  private selected: boolean[] = [];
  private student_user_id = '';

  private async selectCourses() {
    const isOK = await MessageDialog.confirm(`選択コースを登録します。よろしいですか？`);
    if (isOK) {
      const biz = new DaTeacherService();
      const selectedList: string[] = this.teachers.filter((t) => t.selected).map((t) => t.teacher.user_id!);
      await biz.updateSelectedCourse(this.student_user_id, selectedList);
      await MessageDialog.alert(`登録しました。`);
      this.close();
    }
  }

  /**
   * ダイアログを開く
   */
  public async show(user_id: string) {
    this.title = `コース選択`;
    this.student_user_id = user_id;

    const biz = new DaTeacherService();
    const response = await biz.getTeachers(Session.getSessionBuildingId());
    this.teachers = response.data;

    // すでに選択されたコースを表示
    const sbiz = new StudentService();
    const courseResponse = await sbiz.getDaStudentSelectedCourse(user_id);
    const courses = courseResponse.data;
    this.teachers = this.teachers
      .filter((i) => i.da_teacher.is_shown_admin_page)
      .map((t) => {
        const findCourse = courses.find((c) => c.teacher_user_id === t.teacher.user_id);
        t.selected = !!findCourse;
        return t;
      });

    await (this.$refs['da_select_course_dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['da_select_course_dialog'] as CommonDialog).hide();
  }
}
